module.exports = __webpack_public_path__ + "img/icon-8.649bbd96.svg";